<template>
  <div>
    <div v-if="successPost" class="d-flex justify-content-center">
      <div class="alert alert-success text-center w-95" role="alert">
        <span class="font-weight-bold">Your insurance data has been saved successfully !</span><br>
        <span class="font-size-small">You can check your insurance data by clicking on "View Previous" button.</span>
        <button @click="hideShowAlertMessage" type="button" class="float-right btn btn-outline-secondary btn-sm">X</button>
      </div>
    </div>
    <form @submit.prevent="onSubmit">
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.companyname.$touch()" v-model="userDataForm.companyname" type="text" id="companyName" class="form-control" placeholder="Company to be insured">
            <div class="input-group-append">
              <label for="companyName" class="input-group-text bg-color-grey text-white">Company Name</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.companyname.$error">
            <span v-if="!$v.userDataForm.companyname.minLength" class="text-danger">* Please enter company name with at least {{ $v.userDataForm.companyname.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.companyname.minLength && !$v.userDataForm.companyname.required">
            <span v-if="!$v.userDataForm.companyname.required" class="text-danger">* Please enter company name !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.address.$touch()" v-model="userDataForm.address" type="text" name="companyAddress" id="companyAddress" class="form-control" placeholder="Address of the company">
            <div class="input-group-append">
              <label for="companyAddress" class="input-group-text bg-color-grey text-white">Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.address.$error">
            <span v-if="!$v.userDataForm.address.minLength" class="text-danger">* Please enter company address with at least {{ $v.userDataForm.address.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.address.minLength && !$v.userDataForm.address.required">
            <span v-if="!$v.userDataForm.address.required" class="text-danger">* Please enter company address !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.phonenumber.$touch()" v-model="userDataForm.phonenumber" type="tel" name="companyPhone" id="companyPhone" class="form-control" placeholder="Phone Number">
            <div class="input-group-append">
              <label for="companyPhone" class="input-group-text bg-color-grey text-white">Telephone</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.phonenumber.$error">
            <span v-if="!$v.userDataForm.phonenumber.minLength" class="text-danger">* Please a phone number with at least {{ $v.userDataForm.phonenumber.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.minLength && !$v.userDataForm.phonenumber.numeric">
            <span v-if="!$v.userDataForm.phonenumber.numeric" class="text-danger">* Phone number must contain only digits !</span>
            <br v-if="!$v.userDataForm.phonenumber.numeric && !$v.userDataForm.phonenumber.required">
            <span v-if="!$v.userDataForm.phonenumber.required" class="text-danger">* Please enter a phone number !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.email.$touch()" v-model="userDataForm.email" type="email" name="companyEmail" id="companyEmail" class="form-control" placeholder="Email Address">
            <div class="input-group-append">
              <label for="companyEmail" class="input-group-text bg-color-grey text-white">Email Address</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.email.$error">
            <span v-if="!$v.userDataForm.email.email" class="text-danger">* Please enter a valid email address !</span>
            <br v-if="!$v.userDataForm.email.email && !$v.userDataForm.email.required">
            <span v-if="!$v.userDataForm.email.required" class="text-danger">* Please enter email address !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.zipcode.$touch()" v-model="userDataForm.zipcode" type="number" name="companyZipCode" id="companyZipCode" class="form-control" placeholder="Zip Code">
            <div class="input-group-append">
              <label for="companyZipCode" class="input-group-text bg-color-grey text-white">Zip Code</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.zipcode.$error">
            <span v-if="!$v.userDataForm.zipcode.numeric" class="text-danger">* Zip code must contain only digits !</span>
            <br v-if="!$v.userDataForm.zipcode.numeric && !$v.userDataForm.zipcode.minLength">
            <span v-if="!$v.userDataForm.zipcode.minLength" class="text-danger">* Please enter a zip code with at least {{ $v.userDataForm.zipcode.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.zipcode.required && !$v.userDataForm.zipcode.minLength">
            <span v-if="!$v.userDataForm.zipcode.required" class="text-danger">* Please enter a zip code !</span>
            <br v-if="!$v.userDataForm.zipcode.between">
            <span v-if="!$v.userDataForm.zipcode.between" class="text-danger">* Please enter a zip code between {{ $v.userDataForm.zipcode.$params.between.min }} and {{ $v.userDataForm.zipcode.$params.between.max }} !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.namepromotionevent.$touch()" v-model="userDataForm.namepromotionevent" type="text" name="NamePromotionEvent" id="NamePromotionEvent" class="form-control" placeholder="Name of promotion/event">
            <div class="input-group-append">
              <label for="NamePromotionEvent" class="input-group-text bg-color-grey text-white">Promotion / Event</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.namepromotionevent.$error">
            <span v-if="!$v.userDataForm.namepromotionevent.minLength" class="text-danger">* Please enter promotion or event name with at least {{ $v.userDataForm.namepromotionevent.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.namepromotionevent.required && !$v.userDataForm.namepromotionevent.minLength">
            <span v-if="!$v.userDataForm.namepromotionevent.required" class="text-danger">* Please enter name of promotion or event !</span>
          </div>
        </div>
      </div>
      <div class="d-md-flex justify-content-between">
        <div class="form-group w-md-45 mt-3 mt-3">
          <div class="input-group">
            <label for="descriptionPromotionEvent" class="d-none"></label>
            <textarea @blur="$v.userDataForm.descriptionpromotionevent.$touch()" v-model="userDataForm.descriptionpromotionevent" name="descriptionPromotionEvent" id="descriptionPromotionEvent" class="form-control" placeholder="Description of promotion/event" rows="3"></textarea>
          </div>
          <div v-if="$v.userDataForm.descriptionpromotionevent.$error">
            <span v-if="!$v.userDataForm.descriptionpromotionevent.minLength" class="text-danger">* Please enter event/promotion description with at least {{ $v.userDataForm.descriptionpromotionevent.$params.minLength.min }} characters !</span>
            <br v-if="!$v.userDataForm.descriptionpromotionevent.required && !$v.userDataForm.descriptionpromotionevent.minLength">
            <span v-if="!$v.userDataForm.descriptionpromotionevent.required" class="text-danger">* Please enter a description of promotion/event !</span>
          </div>
        </div>
        <div class="w-md-45 mt-3 mt-3">
          <div class="input-group">
            <input @blur="$v.userDataForm.valueinsured.$touch()" v-model="userDataForm.valueinsured" type="number" name="valueInsurance" id="valueInsurance" class="form-control" placeholder="Value to be insured">
            <div class="input-group-append">
              <label for="valueInsurance" class="input-group-text bg-color-grey text-white">Value ($)</label>
            </div>
          </div>
          <div v-if="$v.userDataForm.valueinsured.$error">
            <span v-if="!$v.userDataForm.valueinsured.numeric" class="text-danger">* Value to be insured can contain only digits</span>
            <br v-if="!$v.userDataForm.valueinsured.numeric && !$v.userDataForm.valueinsured.minLength">
            <span v-if="!$v.userDataForm.valueinsured.minLength" class="text-danger">* Please enter value to be insured with at least {{ $v.userDataForm.valueinsured.$params.minLength.min }} digits !</span>
            <br v-if="!$v.userDataForm.valueinsured.required && !$v.userDataForm.valueinsured.minLength">
            <span v-if="!$v.userDataForm.valueinsured.required" class="text-danger">* Please enter value to be insured !</span>
          </div>
        </div>
      </div>
      <div>
        <div class="d-flex justify-content-start">
          <p class="pLabel mt-3"><span>Does the promotion have official rules ?</span></p>
          <div class="mt-3 ml-3">
            <div :key="value + index" v-for="(value, index) of officialRules" class="custom-control custom-radio custom-control-inline">
              <input @blur="$v.userDataForm.officialrules.$touch()" v-model="userDataForm.officialrules" type="radio" :value="value" :id="'answer' + value" name="answerPromotionRules" class="custom-control-input">
              <label class="custom-control-label" :for="'answer' + value">{{ value }}</label>
            </div>
          </div>
        </div>
        <div v-if="$v.userDataForm.officialrules.$error">
          <span v-if="!$v.userDataForm.officialrules.required" class="text-danger">* Please answer the question above about official rules !</span>
        </div>
      </div>
      <div class="text-center mb-0">
        <button type="submit" class="mt-5 btn bg-color-grey text-white" :disabled="$v.userDataForm.$invalid">Submit</button>
        <div class="divEmptyBox text-center" v-if="$v.userDataForm.$invalid" v-on:click="$store.state.invalidFormAlert">
          <div class="emptyBox"><span class="invisible">Submit</span></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { FORM_PRIZE_VALIDATIONS } from '../../../../validations/formPrize'
export default {
  name: 'InsuranceFormPrize',
  // Get insurance type selected by user and fontStyle
  props: {
    insuranceType: {
      type: String,
      required: true
    },
    defaultFontStyle: {
      type: String,
      default: 'normal'
    }
  },
  data () {
    return {
      officialRules: this.$store.state.officialRules,
      userDataForm: {
        companyname: null,
        address: null,
        phonenumber: null,
        email: null,
        zipcode: null,
        namepromotionevent: null,
        descriptionpromotionevent: null,
        valueinsured: null,
        officialrules: null
      },
      successPost: false
    }
  },
  methods: {
    // show success message if insurance data have been posted successfully
    hideShowAlertMessage () {
      this.successPost = !this.successPost
    },
    // Post insurance object after successfully submission
    onSubmit () {
      let type = null
      this.insuranceType === 'AppInsuranceFormPrize' ? type = 'Prize' : type = null
      console.log('insuranceType = ' + type)
      const formData = {
        typeinsurance: type,
        ownerinsurance: this.$store.getters.email,
        companyname: this.userDataForm.companyname,
        address: this.userDataForm.address,
        phonenumber: this.userDataForm.phonenumber,
        email: this.userDataForm.email,
        zipcode: this.userDataForm.zipcode,
        namepromotionevent: this.userDataForm.namepromotionevent,
        descriptionpromotionevent: this.userDataForm.descriptionpromotionevent,
        valueinsured: this.userDataForm.valueinsured,
        officialrules: this.userDataForm.officialrules
      }
      console.log(formData)
      this.$store.dispatch('postInsurance', formData)
        .then(isSuccess => {
          isSuccess === true ? this.successPost = true : this.successPost = false
          console.log('response axios post insurance = ' + isSuccess)
        })
    }
  },
  // Load validations requirements of the insurance form
  validations: FORM_PRIZE_VALIDATIONS
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/shared/insurances/forms/InsuranceFormPrize.vue